__turbopack_context__.v({
  "colorCircle": "styles-module__qoVwpa__colorCircle",
  "colorGrid": "styles-module__qoVwpa__colorGrid",
  "container": "styles-module__qoVwpa__container",
  "label": "styles-module__qoVwpa__label",
});
